import axiosClient from "../axiosClient";

export const downloadAdmissionPdf = async (token, admissionNo) => {
  try {
    const response = await axiosClient.post(
      "/admin/generate_admission.php",
      new URLSearchParams({
        admission_no: admissionNo,
      }),
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/x-www-form-urlencoded",
        },
        responseType: "blob",
      }
    );

    // 🔥 Try to read blob as text
    const text = await response.data.text();

    try {
      // 🔥 Try parsing JSON
      const json = JSON.parse(text);

      // If parsing succeeds and has status false → it's error
      if (json.status === false) {
        return {
          status: "error",
          message: json.message || "Student not found",
        };
      }
    } catch (e) {
      // ❌ Not JSON → means it's real PDF
    }

    // ✅ If not JSON → return blob as PDF
    return {
      status: "success",
      data: response.data,
    };

  } catch (error) {
    return {
      status: "error",
      message: "Unable to generate admission PDF",
    };
  }
};

const applicationApi = {
  downloadAdmissionPdf,
};

export default applicationApi;
